import React, { useEffect, useState } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import {
  Card,
  CardActionArea,
  CardContent,
  CardHeader,
  Grid,
  Grid2,
  Stack,
  Typography,
} from "@mui/material";
import MaterialTypography from "../../components/MaterialTypography";
import {
  AccountBalanceWallet,
  AddCard,
  AssuredWorkload,
  Grid3x3,
  Redeem,
  RequestQuote,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

function Report() {
  const navigate = useNavigate();

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <CardContent sx={{ minHeight: "70vh" }}>
                <Stack direction="row" spacing={0} mb={2}>
                  <MaterialTypography>Report List</MaterialTypography>
                </Stack>

                <Grid container spacing={5} justifyContent="center">
                  {/* First Row */}
                  <Grid item xs={12} sm={4}>
                    <Card
                      sx={{
                        maxWidth: 345,
                        height: 170,
                        transition: "0.3s",
                        justifyContent: "center",
                        alignItems: "center",
                        boxShadow: 3,
                        "&:hover": {
                          boxShadow: 6,
                          backgroundColor: "rgba(0, 0, 0, 0.04)",
                        },
                      }}
                    >
                      <CardActionArea
                        onClick={() => navigate("/report/salary-report")}
                        sx={{
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <CardContent sx={{ textAlign: "center" }}>
                          <MaterialTypography variant="h4" component="div">
                            Salary Report
                          </MaterialTypography>
                          <Typography variant="h2" component="div">
                            <RequestQuote />
                          </Typography>
                        </CardContent>
                      </CardActionArea>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <Card
                      sx={{
                        maxWidth: 345,
                        height: 170,
                        transition: "0.3s",
                        justifyContent: "center",
                        alignItems: "center",
                        boxShadow: 3,
                        "&:hover": {
                          boxShadow: 6,
                          backgroundColor: "rgba(0, 0, 0, 0.04)",
                        },
                      }}
                    >
                      <CardActionArea
                        sx={{
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        onClick={() => navigate("/report/advance-report")}
                      >
                        <CardContent sx={{ textAlign: "center" }}>
                          <MaterialTypography variant="h4" component="div">
                            Advance Report
                          </MaterialTypography>
                          <Typography variant="h2" component="div">
                            <AddCard />
                          </Typography>
                        </CardContent>
                      </CardActionArea>
                    </Card>
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <Card
                      sx={{
                        maxWidth: 345,
                        height: 170,
                        transition: "0.3s",
                        justifyContent: "center",
                        alignItems: "center",
                        boxShadow: 3,
                        "&:hover": {
                          boxShadow: 6,
                          backgroundColor: "rgba(0, 0, 0, 0.04)",
                        },
                      }}
                    >
                      <CardActionArea
                        sx={{
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        onClick={() => navigate("/report/pf-report")}
                      >
                        <CardContent sx={{ textAlign: "center" }}>
                          <MaterialTypography variant="h4" component="div">
                            PF Report
                          </MaterialTypography>
                          <Typography variant="h2" component="div">
                            <AccountBalanceWallet />
                          </Typography>
                        </CardContent>
                      </CardActionArea>
                    </Card>
                  </Grid>

                  {/* Second Row */}
                  <Grid item xs={12} sm={4}>
                    <Card
                      sx={{
                        maxWidth: 345,
                        height: 170,
                        transition: "0.3s",
                        justifyContent: "center",
                        alignItems: "center",
                        boxShadow: 3,
                        "&:hover": {
                          boxShadow: 6,
                          backgroundColor: "rgba(0, 0, 0, 0.04)",
                        },
                      }}
                    >
                      <CardActionArea
                        sx={{
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        onClick={() => navigate("/report/esi-report")}
                      >
                        <CardContent sx={{ textAlign: "center" }}>
                          <MaterialTypography variant="h4" component="div">
                            ESI Report
                          </MaterialTypography>
                          <Typography variant="h2" component="div">
                            <AssuredWorkload />
                          </Typography>
                        </CardContent>
                      </CardActionArea>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <Card
                      sx={{
                        maxWidth: 345,
                        height: 170,
                        transition: "0.3s",
                        justifyContent: "center",
                        alignItems: "center",
                        boxShadow: 3,
                        "&:hover": {
                          boxShadow: 6,
                          backgroundColor: "rgba(0, 0, 0, 0.04)",
                        },
                      }}
                    >
                      <CardActionArea
                        sx={{
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        onClick={() => navigate("/report/bonus-report")}
                      >
                        <CardContent sx={{ textAlign: "center" }}>
                          <MaterialTypography variant="h4" component="div">
                            Bonus Report
                          </MaterialTypography>
                          <Typography variant="h2" component="div">
                            <Redeem />
                          </Typography>
                        </CardContent>
                      </CardActionArea>
                    </Card>
                  </Grid>
                </Grid>
              </CardContent>
            </Stack>
          }
        ></CardHeader>
      </Card>
    </DashboardLayout>
  );
}

export default Report;
